import * as Yup from "yup";

export default Yup.object().shape({
  gender: Yup.string().required("Gender is required"),
  dateOfBirth: Yup.date().typeError("Invalid date format").required("Date is required"),
});
